module.exports = __webpack_public_path__ + "static/media/arrow-down.7af40d10.svg";